export default "__VITE_ASSET__BdSus9$O__"